// extracted by mini-css-extract-plugin
export default {"Tabs":"Tabs_Tabs__rQGjG","Tab":"Tabs_Tab__JKQjW","active":"Tabs_active__uGUKx"};